import { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';

export const MobileFloatingCTA = ({ onClick }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = totalHeight > 0 ? scrolled / totalHeight : 0;
      setVisible(progress >= 0.33);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <button
      onClick={onClick}
      className={`fixed bottom-6 right-4 z-50 flex items-center gap-2 bg-primary text-primary-foreground px-5 py-3 rounded-full shadow-lg active:scale-95 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
      data-testid="floating-cta"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="text-sm font-semibold">Beratung anfragen</span>
    </button>
  );
};
